import { supabase } from '@/lib/supabase'
import { requestQueueBreakGlass } from '@/lib/queueBreakGlass'

export type QueueItem = {
  sql_sha256?: string; git_sha?: string; workflow_approval_id?: string | null
  id: string; version: string; name: string; repo: string
  status: string; held: boolean; emergency: boolean; pr_url: string | null
  last_error: string | null; sql: string | null
}
export type QueueState = {
  items: QueueItem[]; window_open: boolean; paused: boolean
  guard_on: boolean; break_glass_active_until: string | null
}
const previewMock = import.meta.env.VITE_RELEASE_OPS_MOCK === 'true'

export const migrationQueueApi = {
  async state(id: string | null = null, includeSql = false): Promise<QueueState> {
    if (previewMock) return { window_open: false, paused: false, guard_on: true, break_glass_active_until: null, items: [
      { id: 'preview-pending', version: '20271010100000', name: 'preview_emergency', repo: 'jumpstart', status: 'pending', held: false, emergency: true, pr_url: 'https://github.com/the-Otomator/jumpstartapp/pull/3108', last_error: null, sql: includeSql ? '-- Preview only\nSELECT 1;' : null },
      { id: 'preview-held', version: '20271001220200', name: 'preview_held', repo: 'jumpstart', status: 'approved', held: true, emergency: false, pr_url: null, last_error: null, sql: includeSql ? '-- Preview only\nSELECT 1;' : null },
      { id: 'preview-failed', version: '20270930090001', name: 'preview_failed', repo: 'jumpstart', status: 'failed', held: false, emergency: false, pr_url: null, last_error: 'Preview failure example', sql: includeSql ? '-- Preview only\nSELECT 1;' : null },
    ].filter(item => !id || item.id === id) }
    const { data, error } = await supabase.rpc('migration_queue_state', { p_item_id: id, p_include_sql: includeSql })
    if (error) throw error
    if (!data || !Array.isArray(data.items)) throw new Error('Invalid DB queue response')
    return data as QueueState
  },
  async action(id: string, action: 'approve' | 'hold' | 'release' | 'cancel', reason: string) {
    if (previewMock) throw new Error('תצוגה מקומית בלבד — הפעולה אינה נשלחת לשרת')
    if (!reason.trim()) throw new Error('נדרשת סיבה')
    const { error } = action === 'approve'
      ? await supabase.rpc('migration_queue_approve_emergency', { p_item_id: id, p_reason: reason })
      : await supabase.rpc('migration_queue_action', { p_item_id: id, p_action: action, p_reason: reason })
    if (error) throw error
  },
  breakGlass(action: 'open' | 'close', reason: string) {
    return requestQueueBreakGlass(supabase, action, reason, previewMock)
  },
}
